import format from "string-format"

class PlateFrame {
	constructor({rows, cols}) {
		this.rows = rows
		this.cols = cols
	}

	get count() {
		return this.rows.length * this.cols.length
	}

	well_num_to_name(well_num) {
		const row_i = Math.floor(well_num / this.cols.length)
		const col_i = (well_num - row_i * this.cols.length)
		return format("{row}{col}", {
			row: this.rows[row_i].title,
			col: this.cols[col_i].title,
		})
	}

	coords_to_well_num(row, col) {
		return this.cols.length * row + col
	}
}

const plateEmpty_frame = new PlateFrame({
	rows: [],
	cols: []
})

const plate96_frame = new PlateFrame({
	rows: [
		{title: 'A'},
		{title: 'B'},
		{title: 'C'},
		{title: 'D'},
		{title: 'E'},
		{title: 'F'},
		{title: 'G'},
		{title: 'H'},
	],
	cols: [
		{title: '1'},
		{title: '2'},
		{title: '3'},
		{title: '4'},
		{title: '5'},
		{title: '6'},
		{title: '7'},
		{title: '8'},
		{title: '9'},
		{title: '10'},
		{title: '11'},
		{title: '12'},
	]
})

export {PlateFrame, plateEmpty_frame, plate96_frame}